// @styles 
import './styles.scss'

import SidebarResume from 'components/fields/sidebar-resume';
import React, { useState, useContext, useEffect } from 'react';
import ModalFire from 'components/modal-fire';
import ModalStole from 'components/modal-stole';
import Context from 'context/appContext';
import { encrypt } from 'utils/utils';


export default function MapHome() {
    const [dataModal, setDataModal] = useState({});
    const [values, setValues] = useState([]);
    const [info, setInfo] = useState({});
    const { customRequest, valuesMap, setValuesMap } = useContext(Context);

    useEffect(() => {
        valuesMap && setInfo(valuesMap && valuesMap.info);

    }, []);
    useEffect(() => {
        info && getValues()
    }, [info]);

    const getValues = async () => {
        if (info && info.items && info.items.findIndex(x => x.type === "ModalStole") !== -1) {
            const options = JSON.parse(process.env.REACT_APP_FIND_DATA_SERVICE);
            const body = { data: encrypt(JSON.stringify({ filter: { key: "indicerobo" } }), options.key) };
            customRequest(options.url, options.headers, options.method, body).then((res) => {
                const response = res.respuesta && res.respuesta[0];
                const items = response && response.semaforo.length > 0 && response.semaforo;
                items && setValues(items);
            });
        }
    }

    return valuesMap && valuesMap.visible && info ? (
        <>
            {/* <div className='map__container-header'>
                        <div className='map__container__left-button'
                            onClick={() => setValuesMap({ ...valuesMap, visible: false })}
                        >
                            <em className='fal fa-long-arrow-left' /> Volver
                        </div>
                        <div className='map__container__right'>
                            <div className='map__container__right-text'>
                                <p>C.P. {valuesMap.cp ? valuesMap.cp : ''}</p>
                            </div>
                            <div className='map__container__right-img'>
                                <img src={InmuebleP} alt='Imagen inmueble' />
                                <p>{valuesMap.typeProperty}</p>
                            </div>
                        </div>
                    </div> */}
            <div className='map__container-content'>
                <div className='map__container-content__iframe'>
                    <iframe src={info && info.primary && info.primary.url.replace('value', valuesMap.cp ? valuesMap.cp : '')} allowfullscreen></iframe>
                </div>
                <div className='map__container-content-actions'>
                    {info.items && info.items.length > 0 && info.items.map((item) =>
                        item && (
                            <div onClick={() => setDataModal(item)} className='map__container-content-actions-item'>
                                {item.modalicon && item.modalicon.url && (
                                    <img src={item.modalicon.url} alt={item.modaltitle} />
                                )}
                            </div>
                        )
                    )}
                </div>
                <div className='map__container-content-sidebar'>
                    {info && info.primary && <SidebarResume info={info.primary} cost={valuesMap.cost} />}
                </div>
            </div>
            {dataModal && dataModal.type === 'ModalFire' && (<ModalFire info={dataModal} onClose={() => setDataModal({})} />)}
            {dataModal && dataModal.type === 'ModalStole' && values && values.length > 0 &&
                (<ModalStole info={dataModal} values={values} onClose={() => setDataModal({})} />)}

        </>
    ) : ''
}